// extracted by mini-css-extract-plugin
export default {"iconContainer":"DashboardCategories_iconContainer__1Bxoe","titleContainer":"DashboardCategories_titleContainer__eu3Ba","gridTwo":"DashboardCategories_gridTwo__Zhvgc"};